// @ts-nocheck

import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Select, Input, Box } from '@chakra-ui/react';
import { ItemInputSelect } from 'types/ItemInputSelect';
import { useTranslation } from 'react-i18next';

import useDebounce from 'hooks/useDebounce';
import { CollectionProps } from 'types/CollectionProps';
import { searchCollectionByName } from './reqs';
import * as S from './styles';

interface InputSelectWithReqCustomTagProps {
  getVtexName: (value: string) => void;
  getVtexId: (value: string) => void;
  initialValue: string;
  placeholder?: string;
}

export default function InputSelectWithReqCustomTag({
  getVtexName,
  getVtexId,
  initialValue,
  placeholder = 'Selecione uma opção',
}: InputSelectWithReqCustomTagProps) {
  const { t } = useTranslation();
  const { debounce, reset } = useDebounce();
  const containerRef = useRef<HTMLDivElement>(null); // Ref para o container principal
  const [inputValue, setInputValue] = useState<string>('');
  const [optionListVisible, setOptionListVisible] = useState<boolean>(false);
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [isReq, setIsReq] = useState(false);
  const [listOptions, setListOptions] = useState<CollectionProps[]>([]);

  function selectOption(item: CollectionProps) {
    getVtexId(`${item.id}`);
    getVtexName(`${item.name}`);
    setInputValue(item.name);
    setOptionListVisible(false);
    setListOptions([]);
  }

  useLayoutEffect(() => {
    if (inputValue !== '' && optionListVisible) {
      debounce(async () => {
        setIsReq(true);
        await searchCollectionByName(inputValue, setListOptions);
        setIsReq(false);
        reset();
      }, 1000);
    } else {
      debounce(async () => {
        setListOptions([]);
      }, 1001);
    }
  }, [inputValue]);

  useLayoutEffect(() => {
    if (initialValue !== '') {
      setInputValue(initialValue);
    }
  }, []);

  // Detecta clique fora do componente
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOptionListVisible(false); // Fecha a lista se o clique for fora do container
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside); // Limpa o listener ao desmontar
      setListOptions([]);
    };
  }, []);

  return (
    <S.container ref={containerRef}>
      <Input
        placeholder={placeholder}
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onClick={() => setOptionListVisible(true)}
      />

      {optionListVisible && (
        <S.optionsList>
          {!isReq && listOptions.length === 0 && (
            <S.noItens>
              <p>{t('InputSelectWithReqCustomTag.noItensToSelect')}</p>
            </S.noItens>
          )}

          {!isReq && listOptions.length > 0 && (
            <S.listOptions>
              {listOptions.map(item => (
                <button
                  type="button"
                  key={item.id}
                  onClick={() => selectOption(item)}
                >
                  <p>{item.name}</p>
                </button>
              ))}
            </S.listOptions>
          )}

          {isReq && (
            <S.loading>
              <p>{`${t('InputSelectWithReqCustomTag.searching')}...`}</p>
            </S.loading>
          )}
        </S.optionsList>
      )}
    </S.container>
  );
}
